import { EmployerAgreementsService_employerAgreementServiceGetEntitiesByCompanyId } from '@festina/life-general-types/life/hooks/EmployerAgreementsService_employerAgreementServiceGetEntitiesByCompanyId'

export const useFetchEmployerAgreementEntities =
  EmployerAgreementsService_employerAgreementServiceGetEntitiesByCompanyId.useSuspenseQuery
